import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

import "../css/style.css";
import logo from "../images/minda-logo.png";
import { getDealers, register, sendOtp } from "../api";
import { COUNTRY_CODES } from "../constants/countryCodes";
import {handleSendOtp} from './handleSendOtp'

function Reg2() {
  const navigate = useNavigate();
  const { serialNumber } = useParams();

  const [dealers, setDealers] = useState([]);
  const [sendingOtp, setSendingOtp] = useState(false);

  // 🇮🇳 Default India
  const [countryCode, setCountryCode] = useState("+91");
  const isIndia = countryCode === "+91";

  const [formData, setFormData] = useState({
    dealer: null,
    fName: "",
    lName: "",
    mobile: "",
    otp: "",
    email: "",
    whatsapp: "",
    pwd: "",
    cPwd: "",
    addr: "",
    city: "",
    state: "",
    pincode: "",
    machinename: "",
    machSerial: serialNumber || "",
    isInternational: !isIndia,
    countryCode:countryCode
  });

  const [formErr, setFormErr] = useState({
    dealer: "Required",
    fName: "Required",
    lName: "Required",
    mobile: "Required", // only enforced for India
    otp: "Required",
    email: "",
    whatsapp: "",
    pwd: "Required",
    cPwd: "Required",
    addr: "Required",
    city: "Required",
    state: "Required",
    machinename: "Required",
    pincode: "Required",
  });

  useEffect(() => {
    getDealers().then((res) => {
      if (res) setDealers(res);
    });
  }, [serialNumber]);

  const updateForm = (key, value, required) => {
    const fd = { ...formData };
    const fe = { ...formErr };

    fd[key] = value;

    if (required && !value) {
      fe[key] = "Required";
    } else {
      fe[key] = "";
    }

    setFormData(fd);
    setFormErr(fe);
  };

  const handleCountryChange = (value) => {
    const fd = { ...formData };
    const fe = { ...formErr };

    setCountryCode(value);

    if (value === "+91") {
      // India → mobile mandatory
      if (!fd.mobile) {
        fe.mobile = "Required";
      }
    } else {
      // International → mobile not used
      fd.mobile = "";
      fe.mobile = "";
    }

    setFormData(fd);
    setFormErr(fe);
  };

  const sendOtpCall = async() => {
    // 🇮🇳 India: SMS OTP using mobile
    if (sendingOtp) return;
    if (isIndia) {
      if (!formData.mobile) {
        alert("Mobile is required");
        return;
      }
      if (!/^\d{10}$/.test(formData.mobile)) {
        alert("Mobile number must be a 10-digit number");
        return;
      }

      // For India SMS OTP
      sendOtp(formData.mobile).then((resp) => {
        if (resp && resp.success) {
          alert("OTP sent via SMS");
        } else {
          alert("Failed to send OTP");
        }
      });

      return;
    }

    console.log(formData.email)
    // 🌍 International: WhatsApp / Email OTP
    if (!formData.email && !formData.whatsapp) {
      const fe = { ...formErr };
      fe.email = "Email or WhatsApp required";
      fe.whatsapp = "Email or WhatsApp required";
      setFormErr(fe);
      alert("Email or WhatsApp is required for international users");
      return;
    }

    const contact = {
        email: formData.email || undefined,
        whatsapp: formData.whatsapp || undefined
    }

    // 👉 later you can change this to sendOtpInternational(contact)
    try {
        setSendingOtp(true);

        // ⚠️ IMPORTANT: handleSendOtp MUST return a Promise that resolves
        const resp = await handleSendOtp(contact);

        if (resp && resp.success) {
        alert(
            `OTP sent to ${
            formData.email || formData.whatsapp || "your contact"
            }`
        );
        } else {
        alert(resp?.message || "Failed to send OTP");
        }
    } catch (err) {
        console.error(err);
        alert("Error while sending international OTP");
    } finally {
        // ✅ THIS makes sure button stops "Please wait"
        setSendingOtp(false);
    }
  };

  const submit = () => {
    // Extra check for international contact
    if (!isIndia && !formData.email && !formData.whatsapp) {
      const fe = { ...formErr };
      fe.email = "Email or WhatsApp required";
      fe.whatsapp = "Email or WhatsApp required";
      setFormErr(fe);
      alert("Email or WhatsApp is invalid");
      return;
    }

    // Check all fields that still have an error
    for (let k of Object.keys(formErr)) {
      if (k && formErr[k]) {
        alert(`${k} is invalid`);
        return;
      }
    }

    // Mobile checks only for India
    if (isIndia) {
      if (!/^\d{10}$/.test(formData.mobile)) {
        alert("Mobile number must be a 10-digit number");
        return;
      }
    }

    // Password validations
    if (formData.pwd.length < 8) {
      alert("Password must be atleast 8 character long");
      return;
    }
    if (formData.pwd !== formData.cPwd) {
      alert(`Password confirmation doesn't match`);
      return;
    }
    if (!formData.pwd.match(/[A-Z]/g)) {
      alert(`Password must contain Capital letter`);
      return;
    }
    if (!formData.pwd.match(/[a-z]/g)) {
      alert(`Password must contain small letter`);
      return;
    }
    if (!formData.pwd.match(/[0-9]/g)) {
      alert(`Password must contain number letter`);
      return;
    }

    const payload = {
      ...formData,
      countryCode,
      isInternational: !isIndia,
    };

    register(payload).then((resp) => {
      if (resp && resp.success) {
        if (resp.token) {
          sessionStorage.setItem("token", resp.token);
          navigate("/home", { replace: true });
        } else {
          alert("Registered successfully");
        }
      } else {
        alert("Failed to register");
      }
    });
  };

  const states = [
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Delhi",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Maharashtra",
    "Madhya Pradesh",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Tripura",
    "Telangana",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
    "Andaman & Nicobar",
    "Chandigarh",
    "Dadra & Nagar Haveli",
    "Daman & Diu",
    "Jammu & Kashmir(UT)",
    "Lakshadweep",
    "Ladakh",
    "Puducherry",
  ];

  return (
    <div className="main-page">
      <div className="login-main">
        <div className="logo">
          <img src={logo} alt="logo" />
        </div>

        <div className="login-wrapper">
          <div className="login-form">
            <div className="form">
              {/* Machine Serial (read-only) */}
              <div className="form-group">
                <label>Machine Serial</label>
                <input
                  type="text"
                  value={formData.machSerial || ""}
                  disabled
                />
              </div>

              {/* Country selection from constant */}
              <div className="form-group">
                <label>Country *</label>
                <select
                  value={countryCode}
                  onChange={(e) => handleCountryChange(e.target.value)}
                >
                  {COUNTRY_CODES.map((c) => (
                    <option key={c.code} value={c.code}>
                      {c.flag ? `${c.flag} ` : ""}{c.label} ({c.code})
                    </option>
                  ))}
                </select>
              </div>

              {/* Dealer */}
              <div className="form-group">
                <label>Dealer *</label>
                <select
                  value={formData.dealer || ""}
                  onChange={(x) => {
                    updateForm("dealer", x.target.value, true);
                  }}
                  tabIndex={0}
                >
                  <option value="">Select Dealer</option>
                  {dealers.map((d) => (
                    <option value={d._id} key={d._id}>
                      {d.name}
                    </option>
                  ))}
                </select>
              </div>
              <span
                style={{ fontSize: "smaller", color: "red", margin: 0 }}
              >
                {formErr["dealer"]}
              </span>

              {/* First Name */}
              <div
                className="form-group"
                onChange={(x) => {
                  updateForm("fName", x.target.value, true);
                }}
              >
                <label>First Name *</label>
                <input type="text" placeholder="First Name *" tabIndex={1} />
              </div>
              <span
                style={{ fontSize: "smaller", color: "red", margin: 0 }}
              >
                {formErr["fName"]}
              </span>

              {/* Last Name */}
              <div
                className="form-group"
                onChange={(x) => {
                  updateForm("lName", x.target.value, true);
                }}
              >
                <label>Last Name *</label>
                <input type="text" placeholder="Last Name *" tabIndex={2} />
              </div>
              <span
                style={{ fontSize: "smaller", color: "red", margin: 0 }}
              >
                {formErr["lName"]}
              </span>

              {/* Contact section – India vs International */}
              {isIndia ? (
                <>
                  {/* 🇮🇳 Mobile + SMS OTP */}
                  <div
                    className="form-group"
                    onChange={(x) => {
                      updateForm("mobile", x.target.value, true);
                    }}
                  >
                    <label>Mobile *</label>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <input
                        type="text"
                        placeholder="Mobile *"
                        tabIndex={3}
                        style={{ flex: 1 }}
                      />
                      <button
                        type="button"
                        className="btn btn-secondary"
                        style={{ marginLeft: "10px" }}
                        onClick={sendOtpCall}
                      >
                        Send OTP
                      </button>
                    </div>
                  </div>
                  <span
                    style={{ fontSize: "smaller", color: "red", margin: 0 }}
                  >
                    {formErr["mobile"]}
                  </span>
                </>
              ) : (
                <>
                  {/* 🌍 International: WhatsApp + Email (one required) */}
                  <div
                    className="form-group !hidden"
                    onChange={(x) => {
                      updateForm("whatsapp", x.target.value, false);
                    }}
                  >
                    <label>WhatsApp (can be used for OTP)</label>
                    <input
                      type="text"
                      placeholder="WhatsApp number with country code"
                      tabIndex={3}
                    />
                  </div>
                  <span
                    style={{ fontSize: "smaller", color: "red", margin: 0 }}
                  >
                    {formErr["whatsapp"]}
                  </span>

                  <div
                    className="form-group"
                    onChange={(x) => {
                      updateForm("email", x.target.value, false);
                    }}
                  >
                    <label>Email (can be used for OTP)</label>
                    <input type="text" placeholder="Email" tabIndex={4} />
                  </div>
                  <span
                    style={{ fontSize: "smaller", color: "red", margin: 0 }}
                  >
                    {formErr["email"]}
                  </span>

                  <div className="form-group" style={{ marginTop: "10px" }}>
                   <button
  type="button"
  className="btn btn-secondary"
  style={{ marginLeft: "10px" }}
  onClick={sendOtpCall}
  disabled={sendingOtp}
>
  {sendingOtp ? "Please wait..." : "Send OTP"}
</button>
                  </div>
                </>
              )}

              {/* OTP */}
              <div
                className="form-group"
                onChange={(x) => {
                  updateForm("otp", x.target.value, true);
                }}
              >
                <label>OTP *</label>
                <input type="text" placeholder="OTP *" tabIndex={5} />
              </div>
              <span
                style={{ fontSize: "smaller", color: "red", margin: 0 }}
              >
                {formErr["otp"]}
              </span>

              {/* Password */}
              <div
                className="form-group"
                onChange={(x) => {
                  updateForm("pwd", x.target.value, true);
                }}
              >
                <label>Password *</label>
                <input type="password" placeholder="Password *" tabIndex={6} />
              </div>
              <span
                style={{ fontSize: "smaller", color: "red", margin: 0 }}
              >
                {formErr["pwd"]}
              </span>

              {/* Confirm Password */}
              <div
                className="form-group"
                onChange={(x) => {
                  updateForm("cPwd", x.target.value, true);
                }}
              >
                <label>Confirm Password *</label>
                <input
                  type="password"
                  placeholder="Confirm Password *"
                  tabIndex={7}
                />
              </div>
              <span
                style={{ fontSize: "smaller", color: "red", margin: 0 }}
              >
                {formErr["cPwd"]}
              </span>

              {/* Address */}
              <div
                className="form-group"
                onChange={(x) => {
                  updateForm("addr", x.target.value, true);
                }}
              >
                <label>Address *</label>
                <input type="text" placeholder="Address *" tabIndex={8} />
              </div>
              <span
                style={{ fontSize: "smaller", color: "red", margin: 0 }}
              >
                {formErr["addr"]}
              </span>

              {/* City */}
              <div
                className="form-group"
                onChange={(x) => {
                  updateForm("city", x.target.value, true);
                }}
              >
                <label>City *</label>
                <input type="text" placeholder="City *" tabIndex={9} />
              </div>
              <span
                style={{ fontSize: "smaller", color: "red", margin: 0 }}
              >
                {formErr["city"]}
              </span>

              {/* State */}
                        {/* State */}
            <div
            className="form-group"
            onChange={(x) => {
                updateForm("state", x.target.value, true);
            }}
            >
            <label>
                {isIndia ? "State *" : "State / Province *"}
            </label>

            {isIndia ? (
                /* India = dropdown */
                <select defaultValue="">
                <option value="" disabled>Select State</option>
                {states.map((s) => (
                    <option key={s} value={s}>{s}</option>
                ))}
                </select>
            ) : (
                /* International = text box */
                <input
                type="text"
                placeholder="Enter your State / Province"
                tabIndex={9}
                />
            )}
            </div>

           
              <span
                style={{ fontSize: "smaller", color: "red", margin: 0 }}
              >
                {formErr["state"]}
              </span>

              {/* Machine Name */}
              <div
                className="form-group"
                onChange={(x) => {
                  updateForm("machinename", x.target.value, true);
                }}
              >
                <label>Machine Name *</label>
                <input
                  type="text"
                  placeholder="Machine Name *"
                  tabIndex={10}
                />
              </div>
              <span
                style={{ fontSize: "smaller", color: "red", margin: 0 }}
              >
                {formErr["machinename"]}
              </span>

              {/* Pincode */}
              <div
                className="form-group"
                onChange={(x) => {
                  updateForm("pincode", x.target.value, true);
                }}
              >
                <label>Pincode *</label>
                <input type="text" placeholder="Pincode *" tabIndex={11} />
              </div>
              <span
                style={{ fontSize: "smaller", color: "red", margin: 0 }}
              >
                {formErr["pincode"]}
              </span>

              {/* Submit */}
              <div
                className="form-group"
                style={{ marginTop: "10px" }}
              >
                <button
                  type="submit"
                  className="btn btn-primary btn-block"
                  tabIndex={12}
                  onClick={submit}
                >
                  Sign Up
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Reg2;